export default "__VITE_ASSET__CFdflGdd__"